import './modifyCharityCardData.scss';

// @vendor
import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import moment from 'moment';
const filterLodash = require('lodash/collection/filter');
const { isEqual } = require('lodash/lang');
const { sortBy } = require('lodash/collection');
// const lodash = require('lodash');

// @components
import OKSelect from 'components/commons/OKSelect/OKSelect';
const { OKMessage } = require('commonsComponents/OKMessage');
import { NGOModalSearcher } from 'components/ngoModalSearcher/ngoModalSearcher';

// @common-components
import { LoadingSection } from 'commonsComponents/loadingSection';
import { OKAutosuggest } from 'commonsComponents/OKAutosuggest';
const OKTooltip = require('components/commons/OKTooltip/OKTooltip');

// @actions
import { setWizardButtonStateByButton, addStep, setWizardTypeChange } from 'actions/okWizard';

// @utils
import { i18n } from 'core/i18n';
const { formatText, FormattedText } = i18n;
import apiURLBuilder from 'core/apiURLBuilder';
import { getFormattedString } from 'utilities/currencyHelper';
const { scrollToTop } = require('commonsUtilities/scrollUtils');
const { getNotSelectedFoundations } = require('utilities/NGOHelper');
const { formatCardNumber } = require('utilities/cardsHelper');
import { APIGet } from 'utilities/APIRequestHelper';
const {
    recordLink,
    recordPath,
    PROC_START,
    PROC_ONG_SEARCHER,
    PROC_ONG_RESULT_CLICK
} = require('utilities/tagging');

// @constants
import { LIMIT_CHARITY_AMOUNT, NGO_MODAL_CARD } from 'constants/index';

let generateAmounts = (amounts, currency) => amounts.map(amount => ({
    value: amount === 'INFINITE' ? 99999999 : amount,
    label: amount === 'INFINITE' ? formatText('ngoAmounts-maxLimit') : getFormattedString({ amount, currency })
}));

const generateAmountsInfinite = (amounts, currency) => amounts.map(amount => ({
    value: amount,
    label: amount === 99999999 ? formatText('ngoAmounts-maxLimit') : getFormattedString({ amount, currency })
}));

export class ModifyCharityCardData extends Component {

    constructor(props) {
        super(props);

        this.charityAmountsMin = generateAmounts([0, 5, 10, 20, 30, 40, 50], 'EUR');
        this.charityAmountsMax = generateAmounts(['INFINITE', 3, 5, 10, 20, 40, 60, 80, 100], 'EUR');
        this.charityAmountsMaxOptions = this.charityAmountsMax;

        if (props.stepData && props.stepData.get('minAmount')) {
            this.changeSelectMaxAmount(props.stepData.get('minAmount'));
        }

        this.state = {
            openModalNGO: false,
            minAmountOld: {},
            minAmount: props.stepData && props.stepData.get('minAmount')
                ?
                {
                    value: props.stepData.get('minAmount'),
                    label: getFormattedString({ amount: props.stepData.get('minAmount'), currency: 'EUR' })
                }
                :
                this.charityAmountsMin[0],
            minAmountError: false,
            maxAmountOld: {},
            maxAmount: props.stepData && props.stepData.get('maxAmount')
                ?
                {
                    value: props.stepData.get('maxAmount'),
                    label: props.stepData.get('maxAmount') === LIMIT_CHARITY_AMOUNT
                        ?
                        formatText('ngoAmounts-maxLimit')
                        :
                        getFormattedString({ amount: props.stepData.get('maxAmount'), currency: 'EUR' })
                }
                :
                this.charityAmountsMax[0],
            maxAmountError: false,
            charityFoundationsOld: [],
            charityFoundations: props.stepData && props.stepData.get('charityFoundations').toJS() || [],
            charityFoundationsError: false,
            charityFoundationsSource: [],
            charityFoundationsSourceError: false,
            loading: false,
            limitsModified: false,
            showSearcher: true
        };
    }

    componentDidMount() {
        this.loadData();
        scrollToTop();
        this.props.onSetAsCurrentStep(this.validate);
        recordPath(window.location.pathname, 'proc-ajustes-ONG', PROC_START);
    }

    componentWillUnmount() {
        this.props.localSetWizardButtonStateByButton('next', {
            loading: false,
            disabled: false
        });
    }

    loadData = async () => {
        const { immCardsById, match: { params: { cardId } }, originCountry } = this.props;

        const baseURL = apiURLBuilder.getURL('solidarity');

        this.setState({
            loading: true
        });

        let newState;

        const dataOngVersion = {
            header: {
                version: 2
            }
        };

        try {
            const result = await APIGet(() => { }, `${baseURL}/ngos?solidarityCorner=true&solidarityCard=true&country=${originCountry}`, dataOngVersion);
            newState = {
                charityFoundationsSource: [...result.map(({
                    uniquename,
                    ngoId,
                    name,
                    iban,
                    description,
                    categories,
                    image,
                    deductible,
                    imagelogo
                }) => ({
                    uniquename,
                    ngoId,
                    name,
                    iban,
                    description,
                    categories,
                    image,
                    deductible,
                    imagelogo,
                    showNotDeductibleMessage: false,
                }))]
            };
        } catch (error) {
            newState = {
                charityFoundationsSourceError: true
            };
        }

        try {
            const result = await APIGet(() => { }, `${baseURL}/ngo-cards/${immCardsById.get(cardId).getIn(['contract', 'number'])}`);
            // We need to check if we have already load this step to maintain the user modified data instead of loading
            // it again from the back.
            if (!Boolean(this.props.stepData)) {
                this.changeSelectMaxAmount(generateAmounts([result.minAmount], 'EUR')[0].value);
                newState = {
                    ...newState,
                    maxAmount: generateAmountsInfinite([result.maxAmount], 'EUR')[0],
                    maxAmountOld: generateAmountsInfinite([result.maxAmount], 'EUR')[0],
                    minAmount: generateAmounts([result.minAmount], 'EUR')[0],
                    minAmountOld: generateAmounts([result.minAmount], 'EUR')[0],
                    charityFoundations: [...result.ngos.map(ngo => ({ suggestion: ngo }))],
                    charityFoundationsOld: [...result.ngos.map(ngo => ({ suggestion: ngo }))],
                    loading: false
                };
            } else {
                newState = {
                    ...newState,
                    maxAmountOld: generateAmountsInfinite([result.maxAmount], 'EUR')[0],
                    minAmountOld: generateAmountsInfinite([result.minAmount], 'EUR')[0],
                    charityFoundationsOld: [...result.ngos.map(ngo => ({ suggestion: ngo }))],
                    loading: false
                };
            }
        } catch (error) {
            newState = {
                ...newState,
                charityFoundationsError: error.error.status !== 400,
                loading: false
            };
        }
        this.setState(newState);
    };

    changeSelectMaxAmount = (amount) => {
        const index = this.charityAmountsMax.filter(function (c) {
            return c.value >= amount;
        });
        this.charityAmountsMaxOptions = index;
    };

    handleSetAmount = (data, origin) => {
        if (origin === 'min') {
            this.changeSelectMaxAmount(data.value);

            this.setState({
                minAmount: data,
                minAmountError: false,
                limitsModified: true,
                maxAmount: this.state.maxAmount.value <= data.value ? this.charityAmountsMaxOptions[1] : this.state.maxAmount
            },
                () => {
                    this.changeSummaryInformation()
                });
        } else {
            this.setState({
                maxAmount: data,
                maxAmountError: false,
                limitsModified: true
            },
                () => {
                    this.changeSummaryInformation()
                });
        }
    };

    handleSelectCharityFoundation = (charityFoundation, selectedValue = 1) => {
        const newCharityFoundationsSource = filterLodash(this.state.charityFoundationsSource, function (foundation) {
            return (foundation.ngoId !== charityFoundation.suggestion.ngoId)
        });

        charityFoundation.suggestion.showNotDeductibleMessage = !charityFoundation.suggestion.deductible;
        recordLink(PROC_ONG_SEARCHER, PROC_ONG_RESULT_CLICK + charityFoundation.suggestion.name, selectedValue);

        if (this.state.charityFoundations.length <= 0 || !Boolean(this.state.charityFoundations.find(cf =>
            cf.suggestion.ngoId === charityFoundation.suggestion.ngoId))) {
            this.setState({
                openModalNGO: false,
                charityFoundations: [...this.state.charityFoundations, charityFoundation],
                charityFoundationsError: false,
                showSearcher: false,
                charityFoundationsSource: newCharityFoundationsSource
            },
                () => {
                    this.changeSummaryInformation()
                });
        }
    };

    handleDeleteCharityFoundation = ngoId => {
        const charityDelete = [...this.state.charityFoundations.filter(
            charityFoundation => charityFoundation.suggestion.ngoId === ngoId
        )];

        this.setState({
            charityFoundations: [...this.state.charityFoundations.filter(
                charityFoundation => charityFoundation.suggestion.ngoId !== ngoId
            )],
            charityFoundationsSource: this.state.charityFoundationsSource.concat(charityDelete[0].suggestion),
            charityFoundationsError: false,
            showSearcher: this.state.charityFoundations.length === 1
        },
            () => {
                this.changeSummaryInformation()
            });
    };

    changeSummaryInformation = () => {
        const { charityFoundations, maxAmount, minAmount } = this.state;
        const { currentStep, localAddStep } = this.props;
        const result = {
            charityFoundations,
            maxAmount: maxAmount.value,
            minAmount: minAmount.value,
            isValid: true
        };

        localAddStep(result, currentStep);
    };

    validate = async () => {

        let error = false;

        if (this.state.maxAmount.value < this.state.minAmount.value) {
            error = true;
            this.setState({
                maxAmountError: true
            });
        }

        if (this.state.charityFoundations.length === 0) {
            error = true;
            this.setState({
                charityFoundationsError: true
            });
        }

        if (error) {
            return {
                isValid: false
            };
        }

        return {
            isValid: true,
            minAmount: this.state.minAmount.value,
            maxAmount: this.state.maxAmount.value,
            charityFoundations: this.state.charityFoundations
        };
    };

    showSearcher = () => {
        this.setState({
            showSearcher: true
        });
    };

    addMoreSection = () => {
        const { showSearcher, charityFoundations } = this.state;

        if (!showSearcher && charityFoundations.length < 5) {
            return (
                <div className="modify-charity-card-data__add-more-message" onClick={() => this.showSearcher()}>
                    <i className="icon retail-loan-personal-data__icon icon-agregar" />
                    <FormattedText value="modifyCharityCard-addMoreMessage" />
                </div>
            )
        }
    };

    openModalNGO = () => {
        this.setState({
            openModalNGO: true
        });
    };

    changeModalState = (value) => {
        this.setState({
            openModalNGO: value
        });
    };

    hasChangedValues = () => {
        const { minAmountOld, maxAmountOld, minAmount, maxAmount, charityFoundationsOld, charityFoundations } = this.state;
        let changeAmounts = false
        let changeNGO = false;
        let changeType = '';

        if (minAmountOld.value !== minAmount.value || maxAmountOld.value !== maxAmount.value) {
            changeAmounts = true;
            changeType = 'amountCharity';
        } else {
            changeAmounts = false;
        }

        if (!isEqual(sortBy(charityFoundationsOld, o => o.suggestion.ngoId), sortBy(charityFoundations, o => o.suggestion.ngoId))) {
            changeNGO = true;
            changeType = changeAmounts ? 'amountNGOCharity' : 'NGOCharity';
        } else {
            changeNGO = false;
        }

        this.props.localSetWizardButtonStateByButton('next', {
            loading: false,
            disabled: !changeAmounts && !changeNGO
        });

        this.props.setWizardTypeChange(changeType)
    };

    renderNoSuggestion = () => {
        return <FormattedText value={'ngoSearcher-noSuggestion'} />
    }

    renderButtonNoSuggestion = () => {
        return <FormattedText value={'ngoModal-buttonModalErrorSuggestion'} />;
    }

    render() {
        const { localSetWizardButtonStateByButton, immCardsById, match: { params: { cardId } } } = this.props;
        const { showSearcher, charityFoundationsSource, charityFoundations } = this.state;
        const cardNumber = formatCardNumber(immCardsById.getIn([cardId, 'number']), 4, '*');
        const beneficiaryName = immCardsById.getIn([cardId, 'beneficiaryNameOnCard']);
        const addMoreSection = this.addMoreSection();
        this.hasChangedValues();

        let newcharityFoundationsSource = charityFoundationsSource;
        newcharityFoundationsSource = !Boolean(this.props.stepData)
            ?
            getNotSelectedFoundations(this.state.charityFoundations, charityFoundationsSource)
            :
            getNotSelectedFoundations(this.props.stepData.get('charityFoundations').toJS(), charityFoundationsSource);

        if (this.state.charityFoundationsSourceError) {
            localSetWizardButtonStateByButton('next', {
                loading: false,
                disabled: true
            });
            return (
                <h4>
                    <FormattedText value="cardPeriodicLoads-connectionError" />
                </h4>
            );
        }

        if (this.state.loading) {
            return (
                <Fragment>
                    <LoadingSection />
                </Fragment>
            );
        }

        return (
            <Fragment>
                <h4 className="step__subtitle">
                    <FormattedText value="modifySolidarityCard-cardDataTitle" />
                </h4>
                <div className="row">
                    <div className="col-xs-6">
                        <FormattedText
                            value="modifySolidarityCard-cardDataCardNumber"
                            className="modify-charity-card-data__detail-title"
                        />
                        <p style={{ fontWeight: 'bold' }}>{cardNumber}</p>
                    </div>
                    <div className="col-xs-6">
                        <FormattedText
                            value="modifySolidarityCard-cardDataHolderNameTitle"
                            className="modify-charity-card-data__detail-title"
                        />
                        <p style={{ fontWeight: 'bold' }}>{beneficiaryName}</p>
                    </div>
                </div>
                <h4 className="step__subtitle">
                    <FormattedText value="modifySolidarityCard-ngoYouAreDonatingTitle" />
                </h4>
                <div className="modify-charity-card-data__ngo-image-selected-wrapper">
                    {
                        this.state.charityFoundations.map((charityFoundation, index) => {
                            if (charityFoundation && charityFoundation.suggestion && charityFoundation.suggestion.name) {
                                let deleteText;
                                if (this.state.charityFoundations.length === 1) {
                                    const tooltipTarget = (
                                        <div className="modify-charity-card-data__delete-image-selected">
                                            <FormattedText
                                                value="configCustomItem-delete"
                                                className="modify-charity-card-data__delete-image-selected-text-disabled"
                                            />
                                        </div>
                                    );
                                    deleteText = (
                                        <OKTooltip
                                            content="modifyCharityCard-tooltipDelete"
                                            offset={[0, -15]}
                                            target={tooltipTarget}
                                        />
                                    )
                                } else {
                                    deleteText = (
                                        <div
                                            onClick={() =>
                                                this.handleDeleteCharityFoundation(charityFoundation.suggestion.ngoId)}
                                            className="modify-charity-card-data__delete-image-selected"
                                        >
                                            <FormattedText
                                                value="configCustomItem-delete"
                                                className="modify-charity-card-data__delete-image-selected-text"
                                            />
                                        </div>
                                    )
                                }
                                return (
                                    <div key={index} className="modify-charity-card-data__ngo-image-selected">
                                        {deleteText}
                                        <div className="modify-charity-card-data__ngo-image-selected-title">{charityFoundation.suggestion.name}</div>
                                    </div>
                                )
                            }
                            return undefined;
                        })
                    }
                </div>
                {addMoreSection}
                {showSearcher && charityFoundations.length < 5 &&
                    <Fragment>
                        <OKAutosuggest
                            dataset={newcharityFoundationsSource}
                            maxItems="5"
                            content="name"
                            datasetKey="name"
                            widthInput="small"
                            format="text"
                            placeholder={formatText('hireSolidarityCard-selectNGOPlaceholderMessage')}
                            noSuggestionComponent={this.renderNoSuggestion()}
                            buttonNoSuggestionComponent={this.renderButtonNoSuggestion()}
                            onSelect={this.handleSelectCharityFoundation}
                            error={this.state.charityFoundationsError}
                            handleOnError={this.openModalNGO}
                            errorMessage={<FormattedText value="hireSolidarityCard-selectNGOErrorMessage" />}
                        />
                        <NGOModalSearcher
                            changeCharityFoundation={this.handleSelectCharityFoundation}
                            typeNGOModal={NGO_MODAL_CARD}
                            openModal={this.state.openModalNGO}
                            closeModal={this.changeModalState}
                            charityFoundations={newcharityFoundationsSource}
                        />
                    </Fragment>
                }
                <h4 className="step__subtitle">
                    <FormattedText value="modifySolidarityCard-donationLimitsSectionTitle" />
                </h4>
                <div className="row">
                    <div className="col-xs-12 col-md-6">
                        <OKSelect
                            clearable={false}
                            label={formatText('hireSolidarityCard-minimumAmountMessage')}
                            matchPos="start"
                            matchProp="label"
                            disabled={false}
                            searchable={false}
                            options={this.charityAmountsMin}
                            onChange={data => this.handleSetAmount(data, 'min')}
                            value={this.state.minAmount}
                            errorState={this.state.minAmountError}
                            errorMessage={<FormattedText value="hireSolidarityCard-minimumAmountErrorMessage" />}
                        />
                    </div>
                    <div className="col-xs-12 col-md-6">
                        <OKSelect
                            clearable={false}
                            label={formatText('hireSolidarityCard-maximumAmountMessage')}
                            matchPos="start"
                            matchProp="label"
                            searchable={false}
                            disabled={false}
                            options={this.charityAmountsMaxOptions}
                            onChange={data => this.handleSetAmount(data, 'max')}
                            value={this.state.maxAmount}
                            errorState={this.state.maxAmountError}
                            errorMessage={<FormattedText value="hireSolidarityCard-maximumAmountErrorMessage" />}
                        />
                    </div>
                </div>
                {
                    this.state.limitsModified && <div className="modify-charity-card-data__info-message"><OKMessage type="informative">
                        <FormattedText value="modifySolidarityCard-donationLimitsSectionWarning" injectedStrings={[
                            moment().endOf('month').add(1, 'days').format('DD-MM-YYYY')
                        ]} />
                    </OKMessage></div>
                }
            </Fragment>
        );
    }
}

ModifyCharityCardData.propTypes = {
    immCardsById: PropTypes.object.isRequired,
    localSetWizardButtonStateByButton: PropTypes.func.isRequired,
    message: PropTypes.string.isRequired,
    onSetAsCurrentStep: PropTypes.func.isRequired,
    match: PropTypes.object.isRequired,
    stepData: PropTypes.object,
    currentStep: PropTypes.number,
    localAddStep: PropTypes.func,
    setWizardTypeChange: PropTypes.func,
    originCountry: PropTypes.string,
};

module.exports.ModifyCharityCardData = connect(
    state => ({
        currency: state.cards.get('byId'),
        immCardsById: state.cards.get('byId'),
        currentStep: state.okWizard.get('currentStep'),
    }),
    {
        localAddStep: addStep,
        localSetWizardButtonStateByButton: setWizardButtonStateByButton,
        setWizardTypeChange: setWizardTypeChange
    }
)(ModifyCharityCardData);
